<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="name" label="检测项目">
        <el-input
          v-model="searchModel.name"
          placeholder="请输入"
          clearable
          @keyup.enter.native.stop="getTableData(true)"
        ></el-input>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sampleName" label="检测项目" min-width="200" header-align="center" fixed></el-table-column>
        <el-table-column prop="calModel" label="计算规格" align="center"></el-table-column>
        <el-table-column prop="actModel" label="实际规格" align="center"></el-table-column>
        <el-table-column prop="unitPrice" label="单价(元)" width="150" align="center"></el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="160" align="center"></el-table-column>

        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <PriceEdit :visible.sync="editVisible" :activeInfo="activeRow" @refresh="getTableData()"></PriceEdit>
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import PriceEdit from './components/PriceEdit';

import { getSamplePriceList } from '@/api/system';

export default {
  components: { TableHeader, PriceEdit },
  data() {
    return {
      collapsed: true,
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        name: ''
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      // 弹窗
      activeRow: {},
      editVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const { data } = await getSamplePriceList({ ...this.searchModel });

      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    handleAdd() {
      this.activeRow = {};
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRow = row;
      this.editVisible = true;
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .el-table__cell {
    position: relative;
  }
  .logo-box {
    padding-left: 40px;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 40px;
      height: auto;
    }
  }
}
</style>
